import { useLingui } from '@lingui/react/macro';

import {
  FilterCheckboxItem,
  FiltersList,
  FiltersSubMenu,
} from '@/design_system/Filters/FiltersDrawer/FiltersDrawer';
import IconTask from '@/icons/Task.svg';
import { TRAITS } from '@/models/entity';

import { useFilters } from '../FiltersState';

export const FiltersTrait = () => {
  const { t, i18n } = useLingui();

  const {
    traits: { traits, setTraits },
  } = useFilters();

  const toggleTrait = (trait: (typeof traits)[number]) => {
    if (traits.includes(trait)) {
      setTraits(traits.filter((t) => t !== trait));
    } else {
      setTraits([...traits, trait]);
    }
  };

  const options = TRAITS.map(({ id, label }) => (
    <FilterCheckboxItem key={id} id={id} label={i18n._(label)} />
  ));

  return (
    <FiltersSubMenu
      id="trait"
      icon={<IconTask />}
      label={t({
        id: 'settings.organization.entities.entities.filters.trait.label',
        message: 'Trait',
      })}
      count={traits.length}
    >
      <FiltersList
        ariaLabel={t({
          id: 'settings.organization.entities.entities.filters.trait.label',
          message: 'Trait',
        })}
        values={traits}
        onChange={toggleTrait}
      >
        {options}
      </FiltersList>
    </FiltersSubMenu>
  );
};
